/**
 * Formats an ISO date string into a human-readable date string.
 *
 * @param iso - The ISO date string to format. If `undefined` or `null`, returns "—".
 * @returns A formatted date string in the format "dd MMM yyyy" (e.g., "01 Jan 2024"),
 *          or "—" if the input is not provided.
 */
export function prettyDate(iso?: string | null): string {
    // Return em dash if no date is provided
    if (!iso) return "—";

    // Parse the ISO string into a Date object
    const date = new Date(iso);

    // Format the date to "dd MMM yyyy"
    return date.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}